import { Modal } from "@dmm-com/rocket-web-ui-library";
import type { ModalProps } from "@dmm-com/rocket-web-ui-library/es6/components/modal";
import styled from "@emotion/styled";
import { createPortal } from "react-dom";

import { runningInBrowser } from "~/const/browser";

const ATTRIBUTE_NAME = {
  MAIN_ROOT: "#main-layout",
} as const;

/**
 * `id = main-layout`が付与されたmainタグ配下にモーダルを表示したいケースで利用する
 * @param props {@link PortalModalProps}
 */
export const PortalModal = (props: ModalProps) => {
  const { children, isOpen, ...modalProps } = props;

  if (!isOpen || !runningInBrowser) return null;

  const element = document.querySelector(ATTRIBUTE_NAME.MAIN_ROOT) as HTMLDivElement;

  return createPortal(
    <CustomModal isOpen={isOpen} {...modalProps}>
      {children}
    </CustomModal>,
    element
  );
};

// HACK: リリース時間に合えば、Modalの方を改修したい
const CustomModal = styled(Modal)`
  > div:nth-of-type(2) {
    padding-left: var(--sal);
    padding-right: var(--sar);
  }
`;
